"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Presentations_module_css_1 = __importDefault(require("./Presentations.module.css"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var front_end_validation_1 = __importDefault(require("@nordicscreen/front-end-validation"));
var types_1 = require("../../Types/types");
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var PermissionContext_1 = require("../common/PermissionContext");
var NewPresentationModal = function (_a) {
    var _b, _c;
    var isShown = _a.isShown, toggle = _a.toggle, resourceType = _a.resourceType;
    var onlineResourceManager = new q_play_core_1.OnlineResourceManager();
    var logger = q_play_core_1.logManager.getLogger();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _d = (0, react_1.useState)("1920"), presentationWidth = _d[0], setPresentationWidth = _d[1];
    var _e = (0, react_1.useState)("1080"), presentationHeight = _e[0], setPresentationHeight = _e[1];
    var _f = (0, react_1.useState)(""), presentationTitle = _f[0], setPresentationTitle = _f[1];
    var _g = (0, react_1.useState)([]), presentationGroups = _g[0], setPresentationGroups = _g[1];
    var _h = (0, react_1.useState)([]), playlistGroups = _h[0], setPlaylistGroups = _h[1];
    var _j = (0, react_1.useState)((_c = (_b = presentationGroups[0]) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : undefined), presentationGroupId = _j[0], setPresentationGroupId = _j[1];
    var _k = (0, react_1.useState)("16:9"), aspectRatio = _k[0], setAspectRatio = _k[1];
    var _l = (0, react_1.useState)(true), areWidthAndHeightInputsDisabled = _l[0], setAreWidthAndHeightInputsDisabled = _l[1];
    var _m = (0, react_1.useState)(""), presentationNameError = _m[0], setPresentationNameError = _m[1];
    var _o = (0, react_1.useState)(""), presentationWidthError = _o[0], setPresentationWidthError = _o[1];
    var _p = (0, react_1.useState)(""), presentationHeightError = _p[0], setPresentationHeightError = _p[1];
    var _q = (0, react_1.useState)("FHD"), chosenResolution = _q[0], setChosenResolution = _q[1];
    var _r = (0, react_1.useState)(false), loading = _r[0], setLoading = _r[1];
    var onResolutionRadioInputChange = (0, react_1.useCallback)(function (event) {
        setChosenResolution(event.target.value);
    }, [setChosenResolution]);
    var resolutionFHD = (0, react_1.useRef)(null);
    var resolution4K = (0, react_1.useRef)(null);
    var resolution8K = (0, react_1.useRef)(null);
    var page = (0, useTypedPage_1.default)();
    var userPermissions = (0, react_1.useContext)(PermissionContext_1.PermissionsContext).userPermissions;
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response_1, responseData, hasGlobalManagerPermission, allowedGroups, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.getPresentationGroups(resourceType)];
                case 1:
                    response_1 = _a.sent();
                    responseData = Object.keys(response_1.data).map(function (key) { return response_1.data[key]; });
                    hasGlobalManagerPermission = userPermissions.some(function (permission) {
                        return (permission.name === "global-presentations-manager" || permission.name === "global-playlists-manager") && permission.resourceType === "global";
                    });
                    allowedGroups = hasGlobalManagerPermission ? responseData : responseData.filter(function (group) {
                        return userPermissions.some(function (permission) {
                            return permission.name === "resource-group-manager" && permission.resourceId === group.id;
                        });
                    });
                    if (resourceType === types_1.PresentationType.PRESENTATION) {
                        setPresentationGroups(allowedGroups);
                    }
                    else if (resourceType === types_1.PresentationType.PLAYLIST) {
                        setPlaylistGroups(allowedGroups);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Getting presentation groups for ".concat(resourceType, " failed"), error_1);
                    if (resourceType === types_1.PresentationType.PRESENTATION) {
                        setPresentationGroups([]);
                    }
                    else if (resourceType === types_1.PresentationType.PLAYLIST) {
                        setPlaylistGroups([]);
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var generatePresentationTitle = function () {
            var now = new Date();
            var date = now.toLocaleDateString("eu-DK", { year: "numeric", month: "2-digit", day: "2-digit" }).split("/").reverse().join("-");
            var presentationTitle = "".concat(page.props.user.name, " ").concat(date);
            setPresentationTitle(presentationTitle);
        };
        if (isShown) {
            generatePresentationTitle();
            fetchData();
        }
        else {
            setPresentationGroups([]);
            setPlaylistGroups([]);
        }
    }, [isShown, resourceType]);
    (0, react_1.useEffect)(function () {
        if (resourceType === types_1.PresentationType.PRESENTATION && presentationGroups.length > 0) {
            setPresentationGroupId(presentationGroups[0].id);
        }
        else if (resourceType === types_1.PresentationType.PLAYLIST && playlistGroups.length > 0) {
            setPresentationGroupId(playlistGroups[0].id);
        }
        else {
            setPresentationGroupId(undefined);
        }
    }, [resourceType, presentationGroups, playlistGroups]);
    var standardSizes = [
        { value: "", text: t("Choose a screen size...") },
        { value: "1:1", text: "1:1", width: 1080, height: 1080 },
        { value: "3:2", text: "3:2", width: 1620, height: 1080 },
        { value: "2:3", text: "2:3", width: 1080, height: 1620 },
        { value: "4:3", text: "4:3", width: 1920, height: 1440 },
        { value: "3:4", text: "3:4", width: 1440, height: 1920 },
        { value: "4:1", text: "4:1", width: 4320, height: 1080 },
        { value: "1:4", text: "1:4", width: 1080, height: 4320 },
        { value: "16:10", text: "16:10", width: 1920, height: 1200 },
        { value: "10:16", text: "10:16", width: 1200, height: 1920 },
        { value: "16:9", text: "16:9", width: 1920, height: 1080 },
        { value: "9:16", text: "9:16", width: 1080, height: 1920 },
        { value: "custom", text: t("Custom") },
    ];
    var getPresentationWidthAndHeight = function (presentationAspectRatio) {
        var size = standardSizes.find(function (size) { return size.value === presentationAspectRatio; });
        if (size.value !== "custom") {
            if (size.value !== "") {
                setPresentationWidth(size.width.toString());
                setPresentationHeight(size.height.toString());
                setPresentationWidthError("");
                setPresentationHeightError("");
                resolutionFHD.current.disabled = false;
                resolution4K.current.disabled = false;
                resolution8K.current.disabled = false;
            }
            setAreWidthAndHeightInputsDisabled(true);
        }
        else {
            setAreWidthAndHeightInputsDisabled(false);
        }
        if (size.value === "custom" || size.value === "") {
            resolutionFHD.current.disabled = true;
            resolution4K.current.disabled = true;
            resolution8K.current.disabled = true;
        }
        setChosenResolution("FHD");
    };
    var changePresentationResolution = (0, react_1.useCallback)(function (resolution) {
        var size = standardSizes.find(function (size) { return size.value === aspectRatio; });
        if (resolution === "FHD") {
            setPresentationWidth(size.width.toString());
            setPresentationHeight(size.height.toString());
        }
        else if (resolution === "4K") {
            setPresentationWidth((size.width * 2).toString());
            setPresentationHeight((size.height * 2).toString());
        }
        else if (resolution === "8K") {
            setPresentationWidth((size.width * 4).toString());
            setPresentationHeight((size.height * 4).toString());
        }
    }, [aspectRatio, setPresentationWidth, setPresentationHeight]);
    var inputValidation = function (event) {
        event.preventDefault();
        var _a = event.target, id = _a.id, value = _a.value;
        switch (id) {
            case "presentationName":
                try {
                    new front_end_validation_1.default(value)
                        .validate("should.have.maxLength", "Title is too long", "255")
                        .check();
                    setPresentationNameError("");
                }
                catch (e) {
                    setPresentationNameError(e[0].message);
                }
                break;
            case "presentationWidth":
                try {
                    new front_end_validation_1.default(value)
                        .validate("should.be.int", "The width should be an integer")
                        .and("should.be.max", "The width is larger than allowed", "2147483647")
                        .check();
                    setPresentationWidthError("");
                }
                catch (e) {
                    setPresentationWidthError(e[0].message);
                }
                break;
            case "presentationHeight":
                try {
                    new front_end_validation_1.default(value)
                        .validate("should.be.int", "The height should be an integer")
                        .check();
                    setPresentationHeightError("");
                }
                catch (e) {
                    logger.error(e[0].message);
                    setPresentationHeightError(e[0].message);
                }
                break;
        }
    };
    var onSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var presentationData, onlineResource, data, e_1, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    setLoading(true);
                    presentationData = {
                        title: presentationTitle,
                        presentation_group_id: presentationGroupId,
                        width: parseInt(presentationWidth),
                        height: parseInt(presentationHeight),
                        type: types_1.PresentationType[resourceType.toUpperCase()]
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    onlineResource = onlineResourceManager.makeJSONRequest("/api/presentations/create", "POST", JSON.stringify(presentationData));
                    return [4 /*yield*/, onlineResource.getDataAsJSON()];
                case 2:
                    data = _a.sent();
                    setPresentationTitle("");
                    setPresentationGroupId(undefined);
                    setPresentationWidth("1920");
                    setPresentationHeight("1080");
                    setAspectRatio("16:9");
                    toggle();
                    window.location.href = data.redirectUrl;
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    error = new Error(e_1.message);
                    logger.error(error.message, error);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: isShown, onClose: toggle, dataCy: "newPresentationModal", dialogClassName: Presentations_module_css_1.default.modalDialog, centered: true, body: react_1.default.createElement("form", { id: "createNewPresentationForm" },
            react_1.default.createElement("div", { className: "".concat(Presentations_module_css_1.default.new_presentation_modal_header, " row"), style: { marginBottom: "10px" } },
                react_1.default.createElement("div", { className: "col-sm" }, t("Presentation details"))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-sm", style: { position: "relative" } },
                    react_1.default.createElement("label", { htmlFor: "presentationName", className: "d-block ns-font-size-15" }, t("Presentation name")),
                    react_1.default.createElement(q_play_components_1.Input, { placeholder: t("My presentation"), id: "presentationName", value: presentationTitle, dataCy: "presentationName", onFocus: function (event) { return event.target.select(); }, className: Presentations_module_css_1.default.new_presentation_modal_input_field, onChange: function (e) {
                            setPresentationTitle(e.target.value);
                            inputValidation(e);
                        }, autoFocus: true }),
                    react_1.default.createElement("p", { style: {
                            position: "absolute",
                            color: "var(--warning-color)",
                            fontFamily: "Geomanist",
                        } }, presentationNameError)),
                react_1.default.createElement("div", { className: "col-sm" },
                    react_1.default.createElement("label", { htmlFor: "presentationGroup", className: "d-block ns-font-size-15" }, t("Group")),
                    react_1.default.createElement("select", { id: "presentationGroup", value: presentationGroupId, className: Presentations_module_css_1.default.new_presentation_group_select, onChange: function (e) {
                            setPresentationGroupId(parseInt(e.target.value));
                        } },
                        react_1.default.createElement("option", { value: "" }, "Select group"),
                        resourceType === types_1.PresentationType.PRESENTATION
                            ? presentationGroups.map(function (group) { return (react_1.default.createElement("option", { key: group.id, value: group.id }, group.name)); })
                            : playlistGroups.map(function (group) { return (react_1.default.createElement("option", { key: group.id, value: group.id }, group.name)); })))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-sm" },
                    react_1.default.createElement("div", { className: "".concat(Presentations_module_css_1.default.new_presentation_modal_header, " row"), style: { marginBottom: "10px", marginTop: "25px" } },
                        react_1.default.createElement("div", { className: "col-sm" }, t("Layout"))),
                    react_1.default.createElement("label", { htmlFor: "aspectRatio", className: "d-block ns-font-size-15" }, t("Standard sizes")),
                    react_1.default.createElement("select", { id: "aspectRatio", value: aspectRatio, style: {
                            height: "47px",
                            borderRadius: "4px",
                            marginTop: "10px",
                            marginBottom: "15px",
                        }, onChange: function (e) {
                            setAspectRatio(e.target.value);
                            getPresentationWidthAndHeight(e.target.value);
                        } }, standardSizes.map(function (option, index) { return (react_1.default.createElement("option", { key: index, value: option.value }, option.text)); })),
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "15px",
                            width: "80%",
                        } },
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("label", { htmlFor: "fhd", style: { marginRight: "5px" } }, "Full HD"),
                            react_1.default.createElement("input", { type: "radio", id: "fhd", name: "resolution", value: "FHD", ref: resolutionFHD, checked: chosenResolution === "FHD", style: { marginRight: "10px" }, onChange: function (e) {
                                    onResolutionRadioInputChange(e);
                                    changePresentationResolution(e.target.value);
                                } })),
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("label", { htmlFor: "4k", style: { marginRight: "5px" } }, "4K"),
                            react_1.default.createElement("input", { type: "radio", id: "4k", name: "resolution", value: "4K", ref: resolution4K, checked: chosenResolution === "4K", style: { marginRight: "10px" }, onChange: function (e) {
                                    onResolutionRadioInputChange(e);
                                    changePresentationResolution(e.target.value);
                                } })),
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("label", { htmlFor: "8k", style: { marginRight: "5px" } }, "8K"),
                            react_1.default.createElement("input", { type: "radio", id: "8k", name: "resolution", value: "8K", checked: chosenResolution === "8K", ref: resolution8K, style: { marginRight: "10px" }, onChange: function (e) {
                                    onResolutionRadioInputChange(e);
                                    changePresentationResolution(e.target.value);
                                } }))),
                    react_1.default.createElement("label", { htmlFor: "presentationWidth", className: "d-block ns-font-size-15" }, t("Presentation Width")),
                    react_1.default.createElement(q_play_components_1.Input, { disabled: areWidthAndHeightInputsDisabled, placeholder: t("Width in pixels"), id: "presentationWidth", value: presentationWidth, dataCy: "width", className: Presentations_module_css_1.default.new_presentation_modal_input_field, onChange: function (e) {
                            setPresentationWidth(e.target.value);
                            inputValidation(e);
                        } }),
                    react_1.default.createElement("p", { style: { color: "var(--warning-color)", fontFamily: "Geomanist" } }, presentationWidthError),
                    react_1.default.createElement("label", { htmlFor: "presentationHeight", className: "d-block ns-font-size-15" }, t("Presentation Height")),
                    react_1.default.createElement(q_play_components_1.Input, { disabled: areWidthAndHeightInputsDisabled, placeholder: t("Height in pixels"), id: "presentationHeight", value: presentationHeight, dataCy: "height", className: Presentations_module_css_1.default.new_presentation_modal_input_field, onChange: function (e) {
                            setPresentationHeight(e.target.value);
                            inputValidation(e);
                        } }),
                    react_1.default.createElement("p", { style: { color: "var(--warning-color)", fontFamily: "Geomanist" } }, presentationHeightError)),
                react_1.default.createElement("div", { className: "col-sm", style: { display: "flex", alignItems: "center" } },
                    react_1.default.createElement("div", { style: {
                            height: "300px",
                            width: "300px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        } }, aspectRatio !== "custom" && aspectRatio !== "" && (react_1.default.createElement("div", { style: {
                            width: parseInt(presentationWidth) / 7,
                            height: parseInt(presentationHeight) / 7,
                        }, className: Presentations_module_css_1.default.new_presentation_aspect_ratio },
                        react_1.default.createElement("p", { style: {
                                color: "var(--info-color)",
                                fontSize: "32px",
                                fontFamily: "Geomanist-Bold",
                            } }, (0, q_play_core_1.GetAspectRatio)(parseInt(presentationWidth), parseInt(presentationHeight)))))))),
            react_1.default.createElement("div", { className: "d-flex justify-content-center", style: { marginTop: "25.5px" } }, presentationTitle &&
                presentationWidth &&
                aspectRatio &&
                presentationNameError === "" &&
                presentationWidthError === "" &&
                presentationHeightError === "" &&
                typeof presentationGroupId !== "undefined" ? (react_1.default.createElement(q_play_components_1.Button, { onClick: onSubmit, isLoading: loading, isDisabled: loading, id: "store-button", text: t("Create"), variant: "primary", size: "small", style: { width: "122px" }, dataCy: "createPresentationSubmitButton" })) : (react_1.default.createElement(q_play_components_1.Button, { onClick: onSubmit, isDisabled: true, id: "store-button", text: t("Create"), variant: "primary", size: "small", style: { width: "122px" } })))) }));
};
exports.default = NewPresentationModal;
